import { useState, useEffect } from "react";
import { Dropdown, Layout, Menu, Badge, Row, Modal, Avatar, Space } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// icons
import { BellIcon, LogoutIcon } from "@heroicons/react/outline";
//actions
import { logoutAction as logout } from "redux/actions/auth";
import { UserIcon } from "@heroicons/react/outline"; 
import axios from "axios";

const { Header } = Layout;
const { confirm } = Modal;

const DropdownContent = () => (
  <Menu>
    <Menu.Item>1st menu item</Menu.Item>
    <Menu.Item>2nd menu item</Menu.Item>
    <Menu.Item>3rd menu item</Menu.Item>
  </Menu>
);

const AppHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const onLogout = () => {
  //   confirm({
  //     title: "Are you sure you want to logout?",
  //     onOk: async () => {
  //       try {
  //         if (!token) {
  //           console.error("No token found, please log in first");
  //           return;
  //         }
  //         const response = await axios.get('https://bbps.mtmpay.in/Admin/api/admin/logout', {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //         });
  
  //         if (response.status === 200) {
  //           localStorage.removeItem('token');  
  //           dispatch(logout());
  //           navigate("/login");
  //         }
  //       } catch (error) {
  //         console.error("Error during logout:", error);
  //       }
  //     },
  //   });
  // };

  const onLogout = async () => {
    confirm({
      title: "Are you sure you want to logout?",
      onOk: async () => {
        await dispatch(logout());
        navigate("/login");
      },
    });
  };
  

  const handleProfile = () => {
    navigate("/Profile");
  };

  return (
    <Header className="app-header">
      {/* <Badge count={5} offset={[0, 10]}>
                <div className='app-circle-icon'>
                    <Dropdown overlay={DropdownContent} placement='bottomRight'>
                        <BellIcon width={24} height={24} />
                    </Dropdown>
                </div>
            </Badge> */}

      <Row className="link" align="middle" onClick={handleProfile}>
        <Badge offset={[0, 10]}>
          <div className="app-circle-icon mr-8">
            <UserIcon width={24} height={24} />
          </div>
        </Badge>
      </Row>
      <Row className="link" align="middle" onClick={onLogout}>
        <Badge offset={[0, 10]}>
          <div className="app-circle-icon">
            <LogoutIcon width={24} height={24} />
          </div>
        </Badge>
      </Row>
    </Header>
  );
};

export default AppHeader;
